const useIsMobile = (): boolean => {
  const queryString = "(pointer: coarse)";
  const media = window.matchMedia(queryString);
  if (!media) {
    return false;
  }
  return media.matches;
}

export default useIsMobile;